"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Default_1 = require("./Default");
exports.default = Default_1.default;
